import { injectIntl } from 'react-intl';

import ReadSpeakerButton from './ReadSpeakerButton';

export default injectIntl(ReadSpeakerButton);
